import React, { useEffect, useState } from "react";
import { Modal, Toast } from "antd-mobile";
import {
  getProjectCache,
  getUserCache,
  GlobalValueItem,
  makeThumb,
  makeUploadHeaders,
  makeUploadName,
  makeUploadOptions,
  mergeServerUrl,
  OCRAutoCompoleteProps,
  parseListTypeData,
  parseParamsValue,
  ProjectData,
  ValueItem,
  FormData,
  searchFieldScope,
  filterChildrenByDataCode,
  pickOcrFillFields,
  pickFields,
  ScanResult,
} from "./utils";
import alioss from "ali-oss";
import { post as httpPost } from "../../api/createHttpRequest";
import OCRUpload, { UploadFile } from "./OCRUpload";
import { ApiCore } from "../../api";
import storageX from "../../utils/storageX";

const api = new ApiCore();

const OCRAutofill = (props: OCRAutoCompoleteProps) => {
  // 上传文件列表
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  // 当前表单数据
  const [formData, setFormData] = useState<FormData>({} as FormData);
  // 当前表单值
  const [saveValues, setSaveValues] = useState<ValueItem[]>([]);
  // 当前登录者信息
  const [userData] = useState(() => getUserCache());
  // 当前访问的项目信息
  const [projectData] = useState<ProjectData>(() =>
    getProjectCache(props.formId)
  );
  // 表单状态 DataActionUpdate 更新 DataActionInput 保存
  const [dataAction, setDataAction] = useState("DataActionInput");

  //
  useEffect(() => {
    if (Array.isArray(props.savedValues)) {
      setDataAction(props.dataAction);
      for (const item of props.savedValues) {
        if (item.dataCode === props.data.dataCode) {
          if (Array.isArray(item.value)) {
            setFileList(() =>
              (item.value as string[]).map((url) => makeThumb(url))
            );
            break;
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    const data = props.savedValues.reduce(
      (stack, item: GlobalValueItem | ValueItem) => {
        stack[item.dataCode] = item.value ?? "";
        return stack;
      },
      {} as FormData
    );
    setFormData(data);
    setSaveValues(props.savedValues);
  }, [props.savedValues]);

  // 组装Value
  const makeValueItem = (files: UploadFile[]): GlobalValueItem => {
    return {
      deCode: props.data.deCode,
      dataCode: props.data.dataCode,
      value: files.map(({ url }) => url) as string[],
    };
  };

  // 第3步：将识别结果填充到字段
  const fieldFill = async (
    thumb: UploadFile,
    data: GlobalValueItem[],
    scopeFormConfig: any[]
  ) => {
    const properties = props.data.properties;
    const delimiters = properties.delimiters ?? ["~", "--", "-", "－", "～"];
    const scanValues: GlobalValueItem[] = [];

    //
    type a = {
      [key: string]: {
        min: string;
        max: string;
        radio: string;
        other: string;
      };
    };
    const ocrMap: a = {
      //
    };

    // 判断当前表单是否是list类型 list类型仅有一项时是没有#分隔符的
    const pieces = props.data.dataCode.split("#");

    // 作用域下所有
    const fillFields = pickOcrFillFields(scopeFormConfig);

    for (const { dataCode, deCode, value, reference } of data) {
      if (value === null) {
        continue;
      }

      const newCode =
        pieces.length === 2 ? `${dataCode}#${pieces[1]}` : dataCode;

      const currentField = fillFields[newCode];

      if (!currentField) {
        continue;
      }

      let pValue = value;
      if (currentField.type === "unknownDate") {
        // ["2012-9-9", "2012", "-", "9", "-", "9"]
        // eslint-disable-next-line no-useless-escape
        const result = /^(\d{4})(\-|\/)(\d{1,2})(\-|\/)(\d{1,2})/.exec(
          value as string
        );
        if (Array.isArray(result)) {
          // 匹配到的结果前补0
          const pieces: string[] = [1, 3, 5].map((n: number) => {
            return result[n].padStart(2, "0");
          });
          pValue = pieces.join("-");
        }
      } else if(['number', 'decimal'].includes(currentField.type) ){
          pValue = (pValue as string).replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
          pValue = (pValue as string).replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      }
        
        
        else {
        // 匹配到的是输入范围或单位时
        if (reference === "unit" || reference === "range") {
          // 将识别的结果更新到字段中
          // 目前只做了 input-select 组件
          switch (currentField.type) {
            case "input-select":
              // 获取原值方便合并
              let old = ocrMap[newCode] ?? {
                min: currentField.defaultValue?.min,
                max: currentField.defaultValue?.max,
                radio: currentField.defaultValue?.radio,
                other: currentField.defaultValue?.other,
              };

              // 化验单参考范围值
              if (reference === "range") {
                for (const d of delimiters) {
                  const pieces = (value as string).split(d);
                  // 匹配到分隔符号
                  if (pieces.length === 2) {
                    ocrMap[newCode] = {
                      ...old,
                      min: pieces[0],
                      max: pieces[1] ?? "",
                    };
                    break;
                  }
                }
              } else {
                // 没有化验结果单位时跳过
                if (!currentField.optional) {
                  continue;
                }
                // 化验单单位
                let matched = false;
                for (const radio in currentField.optional) {
                  // 匹配到单位
                  if (currentField.optional[radio] === value) {
                    matched = true;
                    ocrMap[newCode] = {
                      ...old,
                      radio,
                      other: "",
                    };
                    break;
                  }
                }
                // 没有匹配到则使用其他
                if (!matched) {
                  ocrMap[newCode] = {
                    ...old,
                    radio: currentField.other ? currentField.other.key : "",
                    other: value as string,
                  };
                }
              }
              break;
            default:
              break;
          }
          continue;
        }
      }

      scanValues.push({
        dataCode: newCode,
        deCode,
        value: pValue,
      });
    }

    // 将特殊字段写入
    for (const dataName in ocrMap) {
      scanValues.push({
        dataCode: dataName,
        deCode: dataName.split("#").shift() as string,
        value: ocrMap[dataName],
      });
    }

    const values = [...scanValues, makeValueItem([...fileList, thumb])];

    const params = {
      formId: String(props.formId),
      submit: dataAction === "DataActionUpdate",
      values: values,
    };

    const { code, message } = dataAction === "DataActionUpdate" ? 
    await api.updateDatas({ formId: String(props.formId), values}) :  
    await api.saveForm(params)
    if (code == "0") {
      Toast.info(
        scanValues.length > 0 ? "请确认识别的数据" : "未匹配到任何数据，请检查图片内容",
        1
      );
      props.updateFun && props.updateFun(values);
    } else {
      Toast.fail(message);
    }
  };

  // 第2步：将OSS地址发给后端识别
  const fetchScanResult = async (imageUrl: string, scopeFormConfig: any[]) => {
    const shareData = {
      ...parseListTypeData(formData, pickFields(scopeFormConfig)),
      imageUrl,
    };

    const properties = props.data.properties;

    const serverUrl = mergeServerUrl(
      properties,
      shareData,
      userData,
      projectData
    );

    let payload: { [key: string]: any } = {};
    for (const name in properties.payload) {
      let value = properties.payload[name];
      if (typeof value === "string") {
        value = parseParamsValue(value, shareData, userData, projectData);
      }
      payload[name] = value;
    }
    const result = (await httpPost(serverUrl, payload)) as ScanResult;

    if (result.code === 0) {
      return result.data;
    }
    Toast.fail(result.message);
  };

  // 第1步：上传图片到OSS
  const startUpload = async (file: File) => {
    const pieces = await makeUploadOptions();

    if (!pieces) {
      return;
    }

    const [prefix, options] = pieces;

    const client = new alioss(options);

    const pathname = makeUploadName(prefix, file);

    if (!pathname) {
      return;
    }

    // 上传图片到OSS
    const result = await client.put(pathname, file, {
      timeout: 600 * 1000,
      headers: makeUploadHeaders(props.formId),
    });

    if (result.res.status !== 200) {
      Toast.fail("上传失败，请重试！");
      return;
    }

    const thumb = makeThumb(result.url);

    setFileList((pre) => [...pre, thumb]);


    if (props.autoOcr) {
      // 确认表单填充作用域
      const scopeFormConfig = searchFieldScope(
        props.data.dataCode,
        filterChildrenByDataCode(props.formConfig, props.data.dataCode)
      );

      // 去后端识别 必须返回 dataCode, deCode, value, reference
      const data = (await fetchScanResult(
        result.url,
        scopeFormConfig
      )) as GlobalValueItem[];
      
      // 将结果填充到字段
      if (Array.isArray(data) && data.length > 0) {
        await fieldFill(thumb, data, scopeFormConfig);
      } else {
        saveResourceFile(makeValueItem([...fileList, thumb]))
        Toast.fail("系统未识别到数据");
      }
    }else{
      saveResourceFile(makeValueItem([...fileList, thumb]))
    }
  };

  // 保存原始的资源文件
  const saveResourceFile = async (value: GlobalValueItem)=>{

    if (dataAction === "DataActionInput") {
      const params = {
        formId: String(props.formId),
        submit: false,
        values: [value]
      }
      
      // ocr识别数据之后直接保存了，和网页端不同，所以提前做一个数据校验
      const {code, message} = await api.saveForm(params)
      if (code == '0') {
        props.updateFun && props.updateFun(params.values);
      } else {
        Toast.fail(message);
      }

    }else if(dataAction === "DataActionUpdate") {
      const params = { formId: String(props.formId), ...value }
      const { code, message } = await api.updateData(params);
      if (code == "0") {
        Toast.success("更新成功！", 1);
        props.updateData()
      } else {
        Toast.fail(message, 1);
      }
    }

  }

  const onUpload = async (file: File) => {
    if (props.autoOcr) {
      if (!props.data.properties) {
        Toast.fail("请确认组件配置项");
        return;
      }
      Toast.loading("正在识别...", 0);
    }
    try {
      await startUpload(file);
    } catch (error) {
      //
      console.log('"', error)
    }
  };

  // 删除图片比较特殊 在修改表单状态删除时调用专有的删除图片方法而不是修改方法
  const onRemove = (file: UploadFile) => {
    Modal.alert("确定删除？", "", [
      {
        text: "取消",
        onPress() {},
      },
      {
        text: "确定",
        onPress: async () => {
          let i: string = "0";
          const files: UploadFile[] = [...fileList];
          for (i in files) {
            if (files[i]["uid"] === file.uid) {
              const removeFile = files.splice(Number(i), 1) as UploadFile[];

              setFileList(files);

              // 表单保存状态 保存当前上传图片
              if (dataAction === "DataActionInput") {
                if (props.autoOcr) {
                  // 清空所有识别的字段数据
                  const scopeConfig = searchFieldScope(
                    props.data.dataCode,
                    filterChildrenByDataCode(
                      props.formConfig,
                      props.data.dataCode
                    )
                  );
                  const fillFields = pickOcrFillFields(scopeConfig);
                  const cleans = Object.keys(fillFields);
                  saveValues.forEach((item) => {
                    if (
                      item.dataCode !== props.data.dataCode &&
                      cleans.includes(item.dataCode)
                    ) {
                      item.value = "";
                    }
                  });
                }
                const params = {
                  formId: String(props.formId),
                  submit: false,
                  values: [...saveValues, makeValueItem(files)],
                };
                const { code, message } = await api.saveForm(params);
                if (code == "0") {
                  Toast.success("删除成功！", 1);
                  props.updateFun && props.updateFun(params.values);
                } else {
                  Toast.fail(message, 1);
                }
              }
              // 表单修改状态 执行删除图片(识别到的数据暂时不清空)
              else if (dataAction === "DataActionUpdate") {
                const params = {
                  formId: String(props.formId),
                  deCode: props.data.deCode,
                  dataCode: props.data.dataCode,
                  dataTenantCode: storageX().user().tenantCode,
                  value: files.map(({ url }) => url),
                };

                const { code, message } = await api.DeleteImageData(params);
                
                if (code == "0") {
                  Toast.success("删除成功！", 1);
                  props.updateData()
                  // getDataById();
                } else {
                  Toast.fail(message, 1);
                }
              }
              break;
            }
          }
        },
      },
    ]);
  };

  return (
    <OCRUpload
      data-i={dataAction}
      onRemove={onRemove}
      onUpload={onUpload}
      fileList={fileList}
    />
  );
};

export default OCRAutofill;
